
import {Row, Col, Card, CardBody, FormGroup, Label, Button, Badge } from "reactstrap"
import React, { Fragment, useEffect, useState } from "react"
import { MEDIA_FIELDS } from "./CONSTANT"
import { FieldInput } from "../../../../components/FieldInput"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import { getPool } from "../../../../api/pools"
import moment from 'moment'
import "./CollectionForm.css"
import SearchSelectBox from "../../../../components/SearchSelectBox"
import { getContractShifts } from "../../../../api/contract"

const PERIOD_SCHEMA = {from: null, to: null, length: null, breakHours: 0, checked: false}


function calcualteHours(period, shift) {
    let hoursLength = 0;

    let shiftFrom = shift?.from;
    let shiftTo = shift?.to;

    const shiftStart = new Date("01/01/2007 " + shiftFrom);
    let shiftEnd = new Date("01/01/2007 " + shiftTo);

    // Adjust for overnight shifts
    if (shiftEnd <= shiftStart) {
        shiftEnd.setDate(shiftEnd.getDate() + 1);
    }

    if (period.from && period.to) {
        let periodStart = new Date("01/01/2007 " + period.from);
        let periodEnd = new Date("01/01/2007 " + period.to);

        if(periodStart == periodEnd) {
            hoursLength = 0
        }

        // Adjust for overnight periods
        if (periodEnd < periodStart) {
            periodEnd.setDate(periodEnd.getDate() + 1);
        }

        const breakHours = period.breakHours;

        // Calculate total working hours including overtime
        hoursLength += (periodEnd - periodStart);

        if(periodStart < shiftStart) {
            hoursLength = 0
        }

        hoursLength /= (1000 * 60 * 60); // Convert milliseconds to hours

        if (hoursLength > breakHours) {
            hoursLength -= breakHours;
        } else {
            hoursLength = 0;
        }
    }

    return { hoursLength };
}

export default function CollectionForm({setPoolData, poolId, employees, setEmployees, validation, isEmployessLoaded, shift, setShift, negativeHours}){

    //// fetch pool

    const [contract, setContract] = useState(null)
    

    // [1] set => contract , validation.contract_id, poolData props, employees props
    const { instenceLoading: poolLoading, instenceError: poolErr } = useGetInstence(
        getPool,
        poolId,
        (response) => {
            if(setPoolData){
                setPoolData(response.data.data.pool)
            }
            setContract(response.data.data.pool.companyContract)
            validation.setFieldValue('contract_id',response.data.data.pool.companyContract.id)

            setEmployees(response.data.data.pool.employees.map(e => ({
                name: e.name, 
                default: true, 
                employee_id: e.id,
                hoursLength: 0,
                periods: []
            })))
        }
    );

    // [2] fill in employess periods during to date selected
    useEffect(() => {
        const isValidTo = validation.values.date_to && parseInt(new Date(validation.values.date_to).getFullYear()) > 2000
        const isValidFrom = validation.values.date_from && parseInt(new Date(validation.values.date_from).getFullYear()) > 2000

        if(isValidFrom && isValidTo && isEmployessLoaded ){
            let numOFDays = Math.abs(new Date(validation.values.date_from) - new Date(validation.values.date_to)) / (1000 * 60 * 60 * 24)
            numOFDays += 1
            setEmployees(
                    employees.map(e => {
                        if(e.periods.length < numOFDays){
                            return {...e, periods: [...e.periods, ...(Array(numOFDays-e.periods.length)).fill(PERIOD_SCHEMA)]}
                        }else if(e.periods.length > numOFDays){
                            return {...e, periods: e.periods.slice(0, numOFDays)}
                        }else{
                            return e
                        }
                    })
                
            )  
        }
    }, [validation.values.date_from, validation.values.date_to, isEmployessLoaded])

    /////

    // [5] handle employees change
    const handleEmployeeChange = (id, val) => {
        // val => {periods: newPeriods, error: error > 0}
        let hours = 0

        if(val.periods){
            val.periods.filter(p => p.from && p.to).map((per, perI) => {
                hours += calcualteHours(per, shift).hoursLength
            })
        }

        setEmployees(em => em.map(emp => {
            if(emp.employee_id == id){
                return {
                    ...emp, 
                    ...val, 
                    ...(val.periods 
                        ? {hoursLength: hours}
                        : {}
                    )
                }
            }else{
                return emp
            }
        }))
    }

    // [4] handle period change
    const handlePeriodChange = (employee_id, oldPeriods, index, val) => {
        // e.employee_id, e.periods, idx, {from: v.target.value} 
        //                                {to: v.target.value}
        //                                {breakHours: v.target.value}        
        let error = 0

        const newPeriods = oldPeriods.map((per, perI) => {
            if(perI == index){
                const newPer = {...per, ...val}

                const {hoursLength} = calcualteHours({...newPer, breakHours: 0}, shift)
                newPer.length = hoursLength - newPer.breakHours

                if(newPer.length <= 0 ){
                    error += 1;
                }
                if(hoursLength > 0){
                    if(newPer.breakHours >= hoursLength){
                        error += 1;
                    }
                }
                return newPer
            }else{  
                return per
            }
        })        
        handleEmployeeChange(employee_id, {periods: newPeriods, error: error > 0})
    }

    return(
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <Row>
                {MEDIA_FIELDS.map(f => (
                  <FieldInput key={f.key} f={f} validation={validation} />
                ))}

                {contract && <Col md={6}>
                  <Label>Shift</Label>
                  <SearchSelectBox
                    type="shifts"
                    label='name'
                    api={getContractShifts}
                    apiMeta={{contractId: contract?.id}}
                    value={shift?.id || null}
                    setValue={e => setShift(e)}
                  />
                </Col>}

                <Col md={12}>
                  <Label className="mt-3 mt-md-0"><b>Hours</b></Label>
                  <Label className="mb-2 d-flex justify-content-between gap-2 flex-wrap">
                    <span>Shift: {shift?.name}</span>
                    <span>Start: {shift?.from}</span>
                    <span>End: {shift?.to}</span>
                  </Label>

                  {/* Negative Hours Component */}
                  {negativeHours}

                  <Row>
                    {/* [3] */}
                    {employees.map((e, i) => (
                      <Fragment key={e.name} >
                        <Col md={12} style={{fontWeight: "bold", fontSize: "16px"}} className="mb-2">
                          {e.name}
                        </Col>
                          
                        {e.error && <div style={{display: "block"}} className="invalid-feedback mb-2">Invalid Period</div>}
                          
                        <Col md={12} style={{paddingLeft: "40px"}}>
                          <Row>
                            <Col md={12}>
                              <div className="d-flex" style={{gap: "10px", alignItems: "center"}}>
                                {/* <Button size="sm" color="primary" onClick={() => handleEmployeeChange(e.employee_id, {periods: [...e.periods, {from: null, to: null, length: null}]})}>
                                  <i className="mdi mdi-plus"></i>  
                                </Button> */}
                                {/* <Label className="mb-0" style={{fontWeight: "bold"}}>Details</Label> */}
                              </div>

                              <Row>
                                {e.periods.length > 0 && <>
                                  <Col md={2}></Col>
                                  <Col md={3}>Start</Col>
                                  <Col md={3}>End</Col>
                                  <Col md={2}>Break</Col>
                                  <Col md={2}>Length (Hour)</Col>
                                  <Col md={12}>
                                    {e.periods.map((period, x) => {
                                      return <Row key={e.name+"-"+x} className="mb-2 period-row" >
                                        {/* <Button size="sm" className="remove-period" color="dark"
                                            onClick={() => handleEmployeeChange(e.employee_id, {periods: e.periods.map((p, pX) => ({...period, id: undefined}))})}>
                                            <i className="mdi mdi-content-duplicate"></i>  
                                        </Button> */}
                                        <Col md={2} style={{fontWeight: "bold"}} className="d-flex justify-content-center gap-3 align-items-center">
                                          {negativeHours && <input 
                                            type="checkbox"
                                            style={{cursor: 'pointer'}} 
                                            checked={period.checked}
                                            onChange={(v) => handlePeriodChange(e.employee_id, e.periods, x, {checked: v.target.checked })}
                                          />}
                                          {moment(new Date((new Date(validation.values.date_from)).getTime() + (1000*60*60*24*x))).format('DD MMM YYYY')}
                                        </Col>

                                        <Col md={3}>
                                          <input 
                                            type="time"
                                            className="form-control" 
                                            value={period.from}
                                            onChange={(v) => {
                                                handlePeriodChange(e.employee_id, e.periods, x, {from: v.target.value })
                                            }}
                                            disabled={e.disabled}
                                          />
                                        </Col>
                                        <Col md={3}>
                                          <input 
                                            type="time" 
                                            className="form-control" 
                                            value={period.to}
                                            onChange={(v) => {
                                                handlePeriodChange(e.employee_id, e.periods, x, {to: v.target.value})
                                            }}
                                            disabled={e.disabled}
                                          />
                                        </Col>
                                        <Col md={2}>
                                          <input 
                                            type="number" 
                                            className="form-control" 
                                            value={period.breakHours}
                                            onChange={(v) => {
                                                handlePeriodChange(e.employee_id, e.periods, x, {breakHours: v.target.value})
                                            }}
                                            disabled={e.disabled}
                                          />
                                        </Col>
                                        <Col md={2}>
                                          <input 
                                            type="text"
                                            disabled 
                                            className="form-control" 
                                            value={period.length}
                                          />
                                        </Col>
                                      </Row>
                                    })}
                                  </Col>
                                </>}
                              </Row>
                            </Col>

                            <Col md={12}>
                                <Row className="mb-2">
                                    <Col md={2} className="mb-2" style={{fontWeight: "bold"}}>Total</Col>
                                        <Col md={8}></Col>
                                        <Col md={2} className="mb-2">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Hours" 
                                                value={employees.find(em => em.employee_id == e.employee_id).hoursLength}
                                                disabled
                                            />
                                        </Col>
                                </Row>
                            </Col> 
                          </Row>
                        </Col>  
                      </Fragment>
                    ))}
                      
                    <Col className="mt-3" md={12} style={{fontWeight: "bold", textAlign: "right", fontSize: "16px"}}>
                      Total: {employees.reduce((acc, em) => acc+parseFloat(em.hoursLength), 0)} Hour
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    )
}